import { Box, Button, IconButton, Modal, Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import CloseIcon from '@mui/icons-material/Close';
import ImageUploadField from '../CommonTextField/ImageUploadField';
import CustomTextField from '../CommonTextField/CustomTextField';
import SuccessModal from '../successModal/SuccessModal';
import { updateFollowUsMedia } from '../../services/FollowUsMedia'; // Assuming you have this API service

const validationSchema = Yup.object({
    image: Yup.mixed().nullable(),
    link: Yup.string().required('The link field is required.'),
});

const MediaManagerModal = ({ open, setOpen, mediaData, onUpdateSuccess }) => {
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const formik = useFormik({
        initialValues: {
            image: null,
            link: mediaData?.thumbnail_media_url || '',
        },
        validationSchema,
        enableReinitialize: true, // This allows the form to update when mediaData changes
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const formData = new FormData();
                if (values.image) {
                    formData.append('thumbnail_media', values.image);
                }
                formData.append('thumbnail_media_url', values.link);
                
                const response = await updateFollowUsMedia(formData, mediaData._id);
                
                if (response) {
                    setSuccessModalOpen(true);
                    onUpdateSuccess(); // Callback to refresh the data in parent
                }
            } catch (error) {
                console.error('Update failed:', error);
            } finally {
                setIsSubmitting(false);
            }
        },
    });

    const handleClose = () => {
        setOpen(false);
        formik.resetForm();
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-happay-customer"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 2,
                        width: { xs: '90%', sm: '500px' },
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #D5D5D5' }}>
                        <Typography id="modal-happy-customer" variant="h5" sx={{ mb: 2 }}>
                            Change Image & Link
                        </Typography>
                        <IconButton onClick={handleClose} sx={{ p: 0, '&:hover': { backgroundColor: 'transparent' } }} disableRipple disableFocusRipple >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <form onSubmit={formik.handleSubmit} style={{ padding: '10px' }}>
                        <ImageUploadField
                            sx={{ mt: 2 }}
                            label="Image"
                            name="image"
                            formik={formik}
                            data={mediaData?.thumbnail_media}
                            imageHeight='70px'
                            imageWidth='70px'
                        />
                        <CustomTextField
                            label="Link"
                            name="link"
                            formik={formik}
                            placeholder="Enter link"
                            size='small'
                            sx={{ mt: 2, width: '100%' }}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3, mt: 4 }}>
                            <Button
                                variant="outlined"
                                sx={{
                                    borderRadius: '10px',
                                    borderColor: '#01A0E2',
                                    color: '#000',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                onClick={handleClose}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{
                                    borderRadius: '10px',
                                    backgroundColor: '#01A0E2',
                                    color: '#fff',
                                    width: '150px',
                                    textTransform: 'none'
                                }}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Updating...' : 'Update'}
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Modal>

            {/* Success Modal */}
            <SuccessModal
                open={successModalOpen}
                onClose={() => {
                    setSuccessModalOpen(false);
                    handleClose();
                }}
                message='Media manager updated successfully'
            />
        </div>
    )
}

export default MediaManagerModal;